export default __webpack_public_path__ + "static/media/benefits_sipbooster_creatoricon.c161e87d.svg";